import { trackEvent } from "./track"

// One click listener for the whole page sends a Fathom event for every button that names one in
// data-track. Being on the document, it keeps working after Vue rebuilds #app and for buttons Vue
// adds later. Names come from the markup, never the button's text, so visitors who translate the
// page don't split the counts. The names are listed in docs/fathom-events.md

// The header Book Tickets button sits in the slide-out menu below this width (Tailwind's lgx)
const PHONE_MENU = "(max-width: 1023px)"

// Vue sets data-track from post titles, which can hold entities such as &#8217; or tags.
// DOMParser doesn't run scripts or load anything
const decode = (name) => {
  if (!/[&<]/.test(name)) {
    return name
  }

  return new DOMParser().parseFromString(name, "text/html").body.textContent
}

const eventName = (target) => {
  const button = target.closest("[data-track]")

  if (button) {
    const name = button.dataset.trackMenu && window.matchMedia(PHONE_MENU).matches
      ? button.dataset.trackMenu
      : button.dataset.track

    return decode(name).replace(/\s+/g, " ").trim()
  }

  // Phone and email links can sit anywhere, including in text editors type. Links in an alert
  // already send "Alert <text>" (Alert.vue)
  const link = target.closest('a[href^="tel:" i], a[href^="mailto:" i]')

  if (link && !link.closest(".alert")) {
    return link.protocol === "tel:" ? "Phone link" : "Email link"
  }

  return ""
}

export const trackClicks = () => {
  // Capture, so a handler that stops the click on its way up can't hide it
  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) {
      return
    }

    const name = eventName(event.target)

    if (name) {
      trackEvent(name)
    }
  }, true)
}
